/**
 * Làm tròn điểm số để tránh sai số dấu phẩy động (IEEE-754 floating-point)
 * Ví dụ: 0.2 * 50 = 10.000000000000002 -> 10
 */
export const roundScore = (score: number, decimals: number = 2): number => {
  const factor = Math.pow(10, decimals);
  return Math.round((Number(score) + Number.EPSILON) * factor) / factor;
};

/**
 * Tính tổng điểm từ danh sách câu hỏi và làm tròn theo số chữ số thập phân chỉ định (mặc định 2)
 */
export const calculateTotalAssignedPoints = (questions: any[], decimals: number = 2): number => {
  if (!Array.isArray(questions)) return 0;
  const rawSum = questions.reduce(
    (sum: number, item: any) => sum + (Number(item?.point) || 0),
    0
  );
  return roundScore(rawSum, decimals);
};
